import React, {Component} from 'react';
import {Box, Flex} from 'rebass';
import {connect} from 'react-redux';
import {searchActions, searchSelectors} from "../../store/search";
import {chatActions} from "../../store/chat";
import {schoolSelectors} from "../../store/school";
import Loading from '../../components/Base/Loading'
import Share from './Share'
import {withRouter} from "react-router";


class ShareRoster extends Component {
	state = {
		share: true,
		isLoading: false
	};

	componentDidMount() {
		const {clearSearch} = this.props;
		clearSearch();
	}

	handleShareRoster = async (selected) => {
		const {isFaculty, firebase, roster} = this.props;
		if (isFaculty) {
			try {
				let rosterRef = firebase.roster(roster.id);
				await rosterRef.update({
					shared_with: selected
				});
			} catch (e) {
				console.log("Error sharing roster: ", e)
			}
		}
	};

	render() {
		const {share, isLoading} = this.state;
		const {roster, loading, faculty, profile, history} = this.props;
		return (
			<Box>
				{(loading || isLoading)
					? <Loading />
					: <Flex width={1}>
						<Share
							visible={share}
							roster={roster}
							handleSave={this.handleShareRoster}
							toggleVisible={() => history.goBack()}
							faculty={faculty}
							profile={profile}
						/>
					</Flex>
				}
			</Box>
		)
	}
}

const mapStateToProps = state => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),
	search: searchSelectors.refreshSearch(state.search),
	filters: searchSelectors.refreshFilters(state.search),
	students: searchSelectors.refreshCurrentResults(state.search),
	placeholder: searchSelectors.refreshPlaceholder(state.search)
});

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchActions.updateSearch(term));
	},
	clearSearch: () => {
		dispatch(searchActions.clearSearch());
	},
	clearFilter: () => {
		dispatch(searchActions.clearFilter());
	},
	updateStudents: (students) => {
		dispatch(searchActions.updateStudents(students))
	},
	updateCurrentChat: (id) => {
		dispatch(chatActions.updateCurrentChat(id))
	}
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ShareRoster))